// extracted by mini-css-extract-plugin
module.exports = {"resultsNumber":"results-module--resultsNumber--Lhf4B","noResults":"results-module--noResults--3rU9g"};